import { render, staticRenderFns } from "./UiAvatar.vue?vue&type=template&id=0f3bee66&"
import script from "./UiAvatar.vue?vue&type=script&lang=js&"
export * from "./UiAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports